// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"186":"bc3942d2","280":"bc3942d2"}[chunkId] + ".chunk.css";
};